import { Chrome } from 'lucide-react';
import { useLocale } from '../hooks/useLocale';
import type { Locale } from '../types/locale';

export const ChromeBadge = () => {
  const { locale } = useLocale();

  const text: Record<Locale, string> = {
    en: 'Install Chrome Extension',
    de: 'Chrome-Erweiterung installieren',
    'pt-BR': 'Instalar Extensão do Chrome',
    'ms-MY': 'Pasang Sambungan Chrome',
    es: 'Instalar Extensión de Chrome',
    fr: 'Installer l\'Extension Chrome',
    ja: 'Chrome拡張機能をインストール',
    id: 'Pasang Ekstensi Chrome',
  };

  return (
    <a
      href="https://chromewebstore.google.com/detail/gpt-watermark-remover/iaekbmafemcgololhmjgppedicomfnil"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 sm:gap-3 px-3 sm:px-6 py-2 sm:py-2.5
                 bg-transparent
                 hover:bg-blue-50/50 dark:hover:bg-blue-950/30
                 rounded-full
                 text-blue-600 dark:text-blue-400
                 font-medium
                 border-2 border-blue-500/60 dark:border-blue-400/60
                 hover:border-blue-600 dark:hover:border-blue-300
                 transition-[background-color,border-color] duration-200
                 group
                 flex-shrink-0
                 w-full sm:w-auto
                 justify-center
                 min-h-[40px]"
      aria-label={text[locale]}
    >
      <div className="relative flex-shrink-0">
        <Chrome
          size={18}
          className="text-blue-600 dark:text-blue-400
                     group-hover:rotate-12
                     transition-transform duration-300"
        />
        <div className="absolute -inset-1 bg-blue-500/20 rounded-full blur-sm
                        opacity-0 group-hover:opacity-100
                        transition-opacity duration-300"
        />
      </div>
      <span className="text-xs sm:text-sm tracking-wide whitespace-nowrap">
        {text[locale]}
      </span>
      <svg
        className="w-3 h-3 sm:w-4 sm:h-4 text-blue-500/70 dark:text-blue-400/70 group-hover:translate-x-1
                   transition-transform duration-300 flex-shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 7l5 5m0 0l-5 5m5-5H6"
        />
      </svg>
    </a>
  );
};
